import { config } from "./config/config";

const BASE_URL = config.api_base_url;

export async function fetchPosts(page = 1, perPage = 10, type = "posts") {
	let data = [];
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/${type}?page=${page}&per_page=${perPage}&_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}

export async function fetchPostsByCategory(page = 1, perPage = 10, categoryId) {
	let data = [];
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/posts?categories=${categoryId}&page=${page}&per_page=${perPage}&_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}

export async function fetchCategories() {
	let data = [];
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/categories?_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}

export async function fetchSinglePost(id, type = "posts") {
	let data;
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/${type}/${id}?_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}

export async function fetchPages(page = 1, perPage = 10) {
	let data = [];
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/pages?page=${page}&per_page=${perPage}&_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}

export async function fetchSinglePage(id) {
	let data;
	try {
		const response = await fetch(
			`${BASE_URL}/wp-json/wp/v2/pages/${id}?_embed`
		);
		data = await response.json();
	} catch (error) {}
	return data;
}
